'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { FilterChipWithMenuContext } from './context/filter-chip-with-menu.context';
import { filterChipWithMenuSelectRecipe } from './styles/filter-chip-with-menu-select.styles';
import type { FilterChipWithMenuSelectPropsInterface } from './types/filter-chip-with-menu-select.types';

export const FilterChipWithMenuSelect = forwardRef<
  HTMLSelectElement,
  FilterChipWithMenuSelectPropsInterface
>((props: FilterChipWithMenuSelectPropsInterface, forwardedRef) => {
  const chipContext = useContext(FilterChipWithMenuContext);
  const {
    children,
    className,
    css: cssProp,
    disabled = chipContext.disabled ?? false,
    onChange = chipContext.onChange,
    value = chipContext.value,
    ...rest
  } = props;

  const styles = css(filterChipWithMenuSelectRecipe.raw({ disabled }), cssProp);

  return (
    <select
      ref={forwardedRef}
      className={cx('c11n', 'c11n_filter-chip-with-menu__select', styles, className)}
      data-c11n-component="FilterChipWithMenu.Select"
      data-c11n-version={__C11N_VERSION__}
      disabled={disabled}
      onChange={onChange}
      value={value}
      {...rest}
    >
      {children}
    </select>
  );
});

FilterChipWithMenuSelect.displayName = 'FilterChipWithMenu.Select';
